export type InvoiceStatus = 'Kladde' | 'Klar til afsendelse' | 'Sendt' | 'Betalt' | 'Annulleret'

export const invoiceStatuses: InvoiceStatus[] = [
  'Kladde',
  'Klar til afsendelse',
  'Sendt',
  'Betalt',
  'Annulleret',
]

export type InvoiceUnit = 'stk.' | 'timer' | 'meter' | 'm²' | 'fast pris'

export const invoiceUnits: InvoiceUnit[] = ['stk.', 'timer', 'meter', 'm²', 'fast pris']

export interface InvoiceLine {
  id: string
  description: string
  quantity: number
  unit: InvoiceUnit
  unitPrice: number
  /** Momssats i procent, fx 25. */
  vatRate: number
  /** Rabat i procent på linjen, fx 10. */
  discount: number
}

export interface Invoice {
  id: string
  invoiceNumber: string

  customerId: string
  caseId?: string
  quoteId?: string

  customerName: string
  customerAddress: string
  customerPostalCode: string
  customerCity: string
  customerEmail: string
  customerPhone: string

  invoiceDate: string
  dueDate: string
  paymentTerms: string
  reference: string

  /**
   * Betalingsoplysninger. Kopieres fra standardværdierne under Indstillinger →
   * Faktura, men gemmes på den enkelte faktura, så senere ændringer af
   * standarderne aldrig ændrer gamle fakturaer.
   */
  bankName: string
  registrationNumber: string
  accountNumber: string
  paymentReference: string
  paymentText: string

  description: string
  lines: InvoiceLine[]

  subtotal: number
  vatAmount: number
  total: number

  customerNote: string
  internalNote: string

  status: InvoiceStatus

  createdAt: string
  updatedAt: string
  sentAt?: string
  paidAt?: string

  /** Forberedt til senere overførsel til Dinero via sikker backend. */
  dineroInvoiceId?: string
}

export interface InvoiceTotals {
  subtotal: number
  vatAmount: number
  total: number
}
